<template>
  <div class="container">
    <h4 class="title is-4">Requester</h4>
    <div class="container has-text-left">
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <router-link :to="{path: '/tools/requester/request'}">
              <div class="card">
                <div class="card-content">
                  <div class="content">
                    <h4>New Request</h4>
                    <h6>Create a new request</h6>
                  </div>
                </div>
              </div>
            </router-link>
          </article>
          <article
              v-for="collection in collections"
              :key="collection.id"
              class="tile is-child box"
          >
            <router-link :to="{path: '/tools/requester/collections/' + collection.id}">
              <div class="card">
                <div class="card-content">
                  <div class="content">
                    <h4>{{collection.name}}</h4>
                    <h6 v-if="collection.requests.length > 0">
                      {{collection.requests.length}} request(s) in this collection
                    </h6>
                    <h6 v-else>No requests.</h6>
                  </div>
                </div>
              </div>
            </router-link>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    components: {},
    name: "screenrequester",
    data() {
      return {};
    },
    computed: {
      ...mapGetters('requester', ['collections']),
    },
    methods: {},
    mounted() {
    },
    unmounted() {

    }
  }
</script>

<style scoped>

</style>